export default __webpack_public_path__ + "static/media/copyright_policy.8fd49ec4.md";